<template>
  <!-- Order Success Modal -->
  <div
    class="modal modal-search-dish fade"
    id="orderSuccess"
    tabindex="-1"
    aria-labelledby="orderSuccessModal"
    aria-hidden="true"
    ref="orderSuccessModal">
    <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-body text-center">
          <img
            class="mb-3 mx-auto"
            src="../assets/order-status/Order-shipped.svg"
            width="80px"
            alt="Order Shipped"
          />
          <h5 class="text-secondary text-center">Order Placed Successfully !!</h5>
        </div>
        <button
          type="button"
          class="btn btn-success"
          data-bs-dismiss="modal"
          aria-label="Close"
          @click="redirectToOrderNow"
        >
          Okay
        </button>
      </div>
    </div>
  </div>

  <!-- Order Failed Modal -->
  <div
    class="modal modal-search-dish fade"
    id="orderFailed"
    tabindex="-1"
    aria-labelledby="orderFailedModal"
    aria-hidden="true"
    ref="orderFailedModal"
  >
    <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-body text-center">
          <img
            class="mb-3 mx-auto"
            src="../assets/order-status/Order-canceled.svg"
            width="80px"
            alt="Order Canceled"
          />
          <h5 class="text-secondary text-center text-danger">Order failed, please try again.</h5>
        </div>
        <button
          type="button"
          class="btn btn-danger"
          data-bs-dismiss="modal"
          aria-label="Close"
        >
          Try Again
        </button>
      </div>
    </div>
  </div>

</template>

<script setup>
import { onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';
import { useCartStore } from '@/stores/cart';

const router = useRouter();
const cartStore = useCartStore();

// References to the modals
const orderSuccessModal = ref(null);
const orderFailedModal = ref(null);

// Function to handle redirection after successful order modal is hidden
const redirectToOrderNow = () => {
  cartStore.resetCart(); // Only clear cart on successful order
  router.push({ name: 'Ordernow' });
};

// Event handler for when the success modal is hidden
const handleSuccessModalHidden = () => {
  redirectToOrderNow();
};

// Event handler for when the failed modal is hidden (do nothing, stay on page)
const handleFailedModalHidden = () => {
  // Don't redirect anywhere, let user retry payment
  console.log('Payment failed modal closed, staying on checkout page');
};

onMounted(() => {
  if (orderSuccessModal.value) {
    // Attach the event listener to the success modal's hidden event
    orderSuccessModal.value.addEventListener('hidden.bs.modal', handleSuccessModalHidden);
  }
  
  if (orderFailedModal.value) {
    // Attach the event listener to the failed modal's hidden event  
    orderFailedModal.value.addEventListener('hidden.bs.modal', handleFailedModalHidden);
  }
});
</script>

<style scoped>
/* Add any component-specific styles here */
</style>
